module.exports = require("@tanstack/react-table");